import React from 'react';
// import * as d3 from 'd3';
// import axios from 'axios';
import {Dropdown} from 'semantic-ui-react';
import { prepareDataForValidation } from 'formik';
import GroupChart from './Charts/GroupChart';
import PieChart from './Charts/PieChart';
import StackChart from './Charts/StackChart';

export default class PerkExpenseBudgetReport extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            teamList: props.team,
            employeeList: props.employee,
            selected: false,
            chartType: 1,
            groupChartData: null,
            stackChartData: null,
            pieChartData: null,
            dropdownOptions : [],
            description: []
        }
    }

    componentDidMount(){
        this.prepareChartData();
    }

    prepareChartData(){
        var groupDat = []
        var groupColumns = ["Team", "Perks", "Expenses"]
        var stackColumn = "name,Perks,Expenses"
        var stackData = "\r"
        var piePerkTeamChildren = []
        var pieExpenseTeamChildren = []
        var dataForDes = []

        this.state.teamList.forEach(team => {
            var piePerkTeamObj = {name: team.name}
            var pieExpenseTeamObj = {name: team.name}
            var piePerkEmployeeList = []
            var pieExpenseEmployeeList = []
            stackData += team.name
            var perkTotal = 0
            var expenseTotal = 0
            this.state.employeeList.filter(emp => {return team._id === emp.teamId}).forEach(employee => {
                if(team.budget > 0 && employee.status === 'active'){
                    perkTotal += team.budget
                }
                if(team.expenseLimit > 0 && (employee.expenseStatus === 'activateHR' || employee.expenseStatus === 'activateEmployee')){
                    expenseTotal += team.expenseLimit
                }
                piePerkEmployeeList.push({
                    name: employee.firstName + ' ' + employee.lastName,
                    value: team.budget > 0 && employee.status === 'active' ? team.budget : 0
                });
                pieExpenseEmployeeList.push({
                    name: employee.firstName + ' ' + employee.lastName,
                    value: team.expenseLimit > 0 && (employee.expenseStatus === 'activateHR' || employee.expenseStatus === 'activateEmployee') ? team.expenseLimit : 0
                })
            })

            dataForDes.push(`Total Budget for ${team.name}: $${perkTotal+expenseTotal}`)

            groupDat.push({
                Team: team.name,
                Perks: perkTotal,
                Expenses: expenseTotal
            });

            piePerkTeamObj['children'] = piePerkEmployeeList;
            pieExpenseTeamObj['children'] = pieExpenseEmployeeList;
            piePerkTeamChildren.push(piePerkTeamObj)
            pieExpenseTeamChildren.push(pieExpenseTeamObj)

            stackData += ',' + String(perkTotal) + ',' + String(expenseTotal) + "\r"
        })

        this.setState({description: dataForDes})

        var group = {
            dat: groupDat,
            columns: groupColumns,
            y: 'Budget Allocated'
        };

        var pie = {
            name: "organization",
            children: [
                {
                    name: 'Perks',
                    children: piePerkTeamChildren
                },
                {
                    name: 'Expenses',
                    children: pieExpenseTeamChildren
                }
            ]
        };

        var stack = stackColumn + stackData;

        this.setState({groupChartData: group})
        this.setState({pieChartData: pie})
        this.setState({stackChartData: stack})
        this.setState({selected: true})
    }

    chartTypeChanged(event, value) {
        this.setState({selected: false})
        this.setState({chartType: value.value})
        this.setState({selected: true})
    }

    render(){
        return (
            <div style={{flex:1, flexDirection: 'column'}}>
                <div style={{flex:1, flexDirection:'row', padding:10}}>
                            <span style={{flex:1}}>Select Chart type:</span>
                            <span style={{flex:3, paddingLeft:20}}>
                                < Dropdown
                                placeholder= 'Select Chart Type'
                                name = 'Select Chart Type'
                                search
                                closeOnChange
                                defaultValue={1}
                                style={{width: '30%', fontFamily: 'SFProText-Regular'}}
                                // inline
                                selection
                                options={[{key: 1, text: 'Grouped Bar Chart (Perk-Expense Budget)', value: 1},
                                        {key: 2, text: 'Pie Chart (Perk-Expense Budget)', value: 2},
                                        {key: 3, text: 'Stacked Chart (Perk-Expense Budget)', value: 3},
                                        ]}
                                onChange = {(e, value) => this.chartTypeChanged(e, value)} 
                            />
                            </span>
                </div>

                {this.state.selected ? 
                    <div>
                        {/* <div ref = {this.pdfRef}> */}
                            {(this.state.chartType === 1 && this.state.groupChartData) ?
                                <GroupChart data={this.state.groupChartData} title={"Perk-Expense Budget Allocation per Team/Employee"} description={this.state.description} />
                            :
                                (this.state.chartType === 2 && this.state.pieChartData) ?
                                    <PieChart data={this.state.pieChartData} title={"Perk-Expense Budget Allocation per Team/Employee"} description={this.state.description} />
                                :
                                    (this.state.chartType === 3 && this.state.stackChartData) ?
                                        <StackChart data={this.state.stackChartData} title={"Perk-Expense Budget Allocation per Team/Employee"} description={this.state.description} />
                                    :
                                        null
                            }
                        {/* </div> */}
                    </div>
                :
                    <div>No Data to Display</div>
                }
            </div>
        )
    }
}